import Auth from '../auth';
import * as StackTrace from 'stacktrace-js';
import _ from 'lodash';
//- See more at: http://engineering.talis.com/articles/client-side-error-logging/#sthash.SBQouIcL.dpuf

export function exceptionHandlerProvider() {
  return {
    $get: function(exceptionLoggingService) {
      'ngInject';
      return exceptionLoggingService;
    }
  };
}

export function ExceptionLoggingService($log, $window) {
  'ngInject';
  function error(exception, cause) {
    // preserve the default behaviour which will log the error
    // to the console, and allow the application to continue running.
    $log.error.apply($log, arguments);

    // now try to log the error to the server side.
    try {
      let errorMessage = exception.toString();

      // use our traceService to generate a stack trace
      StackTrace.fromError(exception).then(stack => {
        $.ajax({
          type: 'POST',
          url: '/api/errorlog',
          headers: {
            Authorization: Auth.getAuthorizationHeader()
          },
          contentType: 'application/json',
          data: JSON.stringify({
            url: $window.location.href,
            message: errorMessage,
            type: 'exception',
            stackTrace: _.map(stack, item => item.toString()),
            cause: cause || 'Not Available'
          })
        });
      });
      //alert(stackTrace);
      // use AJAX (in this example jQuery) and NOT
      // an angular service such as $http
    } catch (loggingError) {
      $log.warn('Error server-side logging failed');
      $log.log(loggingError);
    }
  }

  return error;
}

// As the comment I’ve placed in the code above highlights it is very important that, when posting the
// log statement to your server, you do NOT use the AngularJS $http service. For two reasons, firstly
// it will create a circular dependency which you really want to avoid, and secondly if the AngularJS
// app is fubar’d you still have a chance of logging the error to your server.
